var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-btn-container"},[_c('AdsButton',{attrs:{"compact":true,"disabled":_vm.bulkPrintDisabled,"buttonText":"Print Label"},on:{"click":_vm.printLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }